(() => {
    function findAncestor(el, selector) {
      while (el && el !== document) {
        if (el.matches(selector)) return el;
        el = el.parentElement;
      }
      return null;
    }
  
    async function fetchHiddenPropertyInput(productUrl, variantId) {
      const url = `${productUrl}?variant=${variantId}&section_id=variant-location-prop`;
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) return null;
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      return tmp.querySelector('input[data-pickup-location-property]');
    }
  
    async function enhanceQuickAddForms(root = document) {
      const forms = root.querySelectorAll('product-form form[data-type="add-to-cart-form"]');
      for (const form of forms) {
        if (form.dataset.variantPropEnhanced === 'true') continue;
        form.dataset.variantPropEnhanced = 'true';
  
        const idInput = form.querySelector('input[name="id"]');
        if (!idInput) continue;
        const variantId = idInput.value;
        if (!variantId) continue;
  
        const card = findAncestor(form, '.product-card-wrapper');
        const link = card?.querySelector('a.full-unstyled-link');
        const productUrl = link?.getAttribute('href')?.split('?')[0];
        if (!productUrl) continue;
  
        const hiddenInput = await fetchHiddenPropertyInput(productUrl, variantId);
        if (hiddenInput) {
          // ensure there's not a duplicate
          form.querySelector('input[data-pickup-location-property]')?.remove();
          form.appendChild(hiddenInput);
        }
      }
    }
  
    document.addEventListener('DOMContentLoaded', () => enhanceQuickAddForms());
  
    document.addEventListener('shopify:section:load', (e) => {
      enhanceQuickAddForms(e.target);
    });
  
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => enhanceQuickAddForms());
      } catch (e) {}
    }
  })();